import Vue from 'vue'
import Router from 'vue-router'
import { Role } from '../role/role.js';
import store from '../store/index'
import Activities from '../views/activities/Activities.vue'
import AllActivities from '../views/activities/AllActivities.vue'
import AllActivitiesParticipant from '../views/activities/AllActivitiesParticipant.vue'
import Dashboard from '../views/activities/Dashboard.vue'
import ActivitiesParticipant from '../views/activities/ActivitiesParticipant.vue'
import ActivityOverview from '../views/activities/ActivityOverview.vue'
import PeopleInActivity from '../views/activities/PeopleInActivity.vue'
import BoostersInActivity from '../views/activities/BoostersInActivity.vue'
import TargetGroups from '../views/audiences/TargetGroups.vue'
import BoostersInTargetGroup from '../views/audiences/BoostersInTargetGroup.vue'
import AddTargetGroupBoosters from '../views/audiences/AddTargetGroupBoosters.vue'
import CreateTargetGroup from '../views/audiences/CreateTargetGroup.vue'
import ViewTargetGroup from '../views/audiences/ViewTargetGroup.vue'
import Hubs from '../views/hubs/Hubs.vue'
import AllHubs from '../views/hubs/AllHubs.vue'
import AllHubsParticipant from '../views/hubs/AllHubsParticipant.vue'
import HubOverview from '../views/hubs/HubOverview.vue'
import BoostersInHub from '../views/hubs/BoostersInHub.vue'
import AddHubBoosters from '../views/hubs/AddHubBoosters.vue'
import ShareHub from '../views/hubs/ShareHub.vue'
import PeopleInHub from '../views/hubs/PeopleInHub.vue'
import CreateHub from '../views/hubs/CreateHub.vue'
import ViewHub from '../views/hubs/ViewHub.vue'
import ViewCategory from '../views/hubs/ViewCategory.vue'
import HubActivities from '../views/hubs/HubActivities.vue'
import TargetGroupAnalytics from '../views/audiences/TargetGroupAnalytics.vue'
import TargetGroupAddPeople from '../views/audiences/TargetGroupAddPeople.vue'
//import CreateActivity from '../views/activities/CreateActivity.vue'
import ViewActivityPage from '../views/activities/ViewActivityPage.vue'
import EditActivityPage from '../views/activities/EditActivityPage.vue'
import ViewActivityQuiz from '../views/activities/ViewActivityQuiz.vue'
import ShareActivity from '../views/activities/ShareActivity.vue'
import ShareActivityCSV from '../views/activities/ShareActivityCSV.vue'
import AddActivityBoosters from '../views/activities/AddActivityBoosters.vue'
import Registration from '../views/authentication/Registration.vue'
import CustomLogin from '../views/authentication/CustomLogin.vue'
import SamlLogin from '../views/authentication/SamlLogin.vue'
import Verification from '../views/authentication/Verification.vue'
import ResetPassword from '../views/authentication/ResetPassword.vue'
import SpaceSettings from '../views/spaces/SpaceSettings.vue'
import SpaceAPI from '../views/spaces/SpaceAPI.vue'
import GenerateAccessToken from '../views/spaces/GenerateAccessToken.vue'
import SpaceSAML from '../views/spaces/SpaceSAML.vue'
import Subscription from '../views/spaces/Subscription.vue'
import AddSAMLConfiguration from '../views/spaces/AddSAMLConfiguration.vue'
import SpaceForbidden from '../views/spaces/SpaceForbidden.vue'
import SpaceBoosters from '../views/spaces/SpaceBoosters.vue'
import SpaceUsers from '../views/spaces/SpaceUsers.vue'
import SpaceInvites from '../views/spaces/SpaceInvites.vue'
import SpaceGuests from '../views/spaces/SpaceGuests.vue'
import ConfirmationDeleteSpace from '../views/spaces/ConfirmationDeleteSpace.vue'
import JoinSpace from '../views/spaces/JoinSpace.vue'
import SharedWithMe from '../views/activities/SharedWithMe.vue'
import SharedWithMeHubs from '../views/hubs/SharedWithMeHubs.vue'
import InvitePeopleForm from '../views/spaces/InvitePeopleForm.vue'
import EditActivityQuiz from '../views/activities/EditActivityQuiz.vue'
import ViewActivityScorm from '../views/activities/ViewActivityScorm.vue'
import EditActivityScorm from '../views/activities/EditActivityScorm.vue'
import PageNotFound from '../views/global/PageNotFound.vue'
import PageAccessDenied from '../views/global/PageAccessDenied.vue'
import PageRedirect from '../views/global/PageRedirect.vue'
import TermsOfService from '../views/gdpr/TermsOfService.vue'
import PrivacyPolicy from '../views/gdpr/PrivacyPolicy.vue'
import SpaceNotExist from '../views/spaces/SpaceNotExist.vue'
import ErrorPageHub from '../views/hubs/ErrorPageHub.vue'
import PageMaintenanceMode from '../views/global/PageMaintenanceMode.vue'
import ViewActivityChecklist from '../views/activities/ViewActivityChecklist.vue'
import EditActivityChecklist from '../views/activities/EditActivityChecklist.vue'
import ConnectedHubs from '../views/activities/ConnectedHubs.vue'
import { getSpaceByURLWithoutToken } from "../api/spaceApi";
import ActivityQRCode from '../views/activities/ActivityQRCode.vue'
import HubQRCode from '../views/hubs/HubQRCode.vue'
import MyWorkflows from '../views/workflows/MyWorkflows.vue'
import WorkflowOverview from '../views/workflows/WorkflowOverview.vue'
import PeopleInWorkflow from '../views/workflows/PeopleInWorkflow.vue'
//import OwnersInWorkflow from '../views/workflows/OwnersInWorkflow.vue'
//import AddWorkflowOwners from '../views/workflows/AddWorkflowOwners.vue'
import AddWorkflowPeople from '../views/workflows/AddWorkflowPeople.vue'
import EditWorkflow from '../views/workflows/EditWorkflow.vue'
import SpacePlandaySettings from '../views/spaces/SpacePlandaySettings.vue'
import SpacePlandayUsers from '../views/spaces/SpacePlandayUsers.vue'
import ViewActivitySurvey from '../views/activities/ViewActivitySurvey.vue'
import EditActivitySurvey from '../views/activities/EditActivitySurvey.vue'
import SpaceEduAdminSettings from '../views/spaces/SpaceEduAdminSettings.vue'
import SpaceFortnoxSettings from '../views/spaces/SpaceFortnoxSettings.vue'
import SpaceVismaSettings from '../views/spaces/SpaceVismaSettings.vue'
import SpaceConnections from '../views/spaces/SpaceConnections.vue'
import EduAdminConnection from '../views/activities/EduAdminConnection.vue'
import SurveysInActivity from '../views/activities/SurveysInActivity.vue'
import SurveyOverview from '../views/activities/SurveyOverview.vue'
import SurveyOverviewUser from '../views/activities/SurveyOverviewUser.vue'
import SurveyIndividuals from '../views/activities/SurveyIndividuals.vue'
import ActivityOverviewParent from '../views/activities/ActivityOverviewParent.vue'
import SurveyOverviewParent from '../views/activities/SurveyOverviewParent.vue'
import EmailTemplates from '../views/spaces/EmailTemplates.vue'
import ResponseActivityOwnerRights from '../views/activities/ResponseActivityOwnerRights.vue'
import ResponseHubOwnerRights from '../views/hubs/ResponseHubOwnerRights.vue'
import StoreParent from '../views/store/StoreParent.vue'
import StoreOverview from '../views/store/StoreOverview.vue'
import StoreProducts from '../views/store/StoreProducts.vue'
import StoreOrders from '../views/store/StoreOrders.vue'
import StoreCustomers from '../views/store/StoreCustomers.vue'
import CreateStoreProduct from '../views/store/CreateStoreProduct.vue'
import CreateStoreCustomer from '../views/store/CreateStoreCustomer.vue'
import AttachCustomerToOrder from '../views/store/AttachCustomerToOrder.vue'
import CreateCustomerContact from '../views/store/CreateCustomerContact.vue'
import ViewStoreCustomer from '../views/store/ViewStoreCustomer.vue'
import ViewProduct from '../views/store/ViewProduct.vue'
import ViewProductPublic from '../views/store/ViewProductPublic.vue'
import ViewOrderPublic from '../views/store/ViewOrderPublic.vue'
import RegisterProductPublic from '../views/store/RegisterProductPublic.vue'
import ViewOrder from '../views/store/ViewOrder.vue'
import StorePolicy from '../views/store/StorePolicy.vue'
import MyCertificatesParticipant from '../views/certificates/MyCertificatesParticipant.vue'
import MyCertificates from '../views/certificates/MyCertificates.vue'
// import Callback from '../views/spaces/FortnoxCallback.vue'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
            path: '/',
            name: 'Dashboard',
            component: () => {
                const currentUser = localStorage.space ? JSON.parse(localStorage.space).role : null;
                if (currentUser == 'space_admin' || currentUser == 'booster') {
                    return import ("../views/activities/Dashboard");
                } else if (currentUser == 'guest' || currentUser == 'participant') {
                    return import ("../views/activities/ActivitiesParticipant");
                } else {
                    return import ("../views/global/PageRedirect");
                }
            },

            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true }

        },
        // {
        //     path: '/callback',
        //     name: 'Callback',
        //     component: Callback,
        // },
        {

            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster]
            }
        },
        {

            path: '/activities',
            name: 'Activities',
            component: Activities,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster]
            }
        },
        {

            path: '/all-activities',
            name: 'AllActivities',
            component: AllActivities,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster]
            }
        },
        {

            path: '/all-activities-participant',
            name: 'AllActivitiesParticipant',
            component: AllActivitiesParticipant,
            meta: {
                showTopNavigation: true,
                requiresAuth: true,
                authorize: [Role.participant, Role.guest]
            }
        },
        {
            path: '/dashboard-participant',
            name: 'ActivitiesParticipant',
            component: ActivitiesParticipant,
            meta: {
                showTopNavigation: true,
                requiresAuth: true,
                authorize: [Role.participant, Role.guest]
            }
        },
        {
            path: '/hubs',
            name: 'Hubs',
            component: Hubs,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/all-hubs-participant',
            name: 'AllHubsParticipant',
            component: AllHubsParticipant,
            meta: {
                showTopNavigation: true,
                requiresAuth: true,
                authorize: [Role.participant, Role.guest],
                hideForFreePlan: true
            }
        },
        {
            path: '/all-hubs',
            name: 'AllHubs',
            component: AllHubs,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/hub/create',
            name: 'CreateHub',
            component: CreateHub,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/hub/:id',
            name: 'ViewHub',
            component: ViewHub,
            meta: {
                showHubNavigation: true,
                hideForFreePlan: true
            }
        },
        {
            path: '/hub/:id/category/:categoryId',
            name: 'ViewCategory',
            component: ViewCategory,
            meta: {
                showCategoryNavigation: true,
                hideForFreePlan: true
            }
        },
        {
            path: '/hub/:id/add-activities',
            name: 'HubActivities',
            component: HubActivities,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/hub/:id/overview',
            name: 'HubOverview',
            component: HubOverview,
            meta: { requiresAuth: true },
            hideForFreePlan: true
        },
        {
            path: '/hub/:id/owners',
            name: 'BoostersInHub',
            component: BoostersInHub,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            },
        },
        {
            path: '/hub/:id/owners/add',
            name: 'AddHubBoosters',
            component: AddHubBoosters,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }

        },
        {
            path: '/hub/:id/people',
            name: 'PeopleInHub',
            component: PeopleInHub,
            meta: { requiresAuth: true, hideForFreePlan: true },
        },
        {
            path: '/hub/:id/share',
            name: 'ShareHub',
            component: ShareHub,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }

        },
        {
            path: '/hub/:id/qr-code',
            name: 'HubQRCode',
            component: HubQRCode,
            meta: { requiresAuth: true },
        },
        {
            path: '/hub/:id/request-become-owner/:requestId',
            name: 'ResponseHubOwnerRights',
            component: ResponseHubOwnerRights,
            meta: {
                showHubNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/hub-error-page',
            name: 'ErrorPageHub',
            component: ErrorPageHub,
            meta: {
                hideForFreePlan: true
            }
        },
        /*{
            path: '/activity/create',
            name: 'CreateActivity',
            component: CreateActivity,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster]
            }
        },*/
        {
            path: '/activity/:id/page/:pageId?',
            name: 'ViewActivityPage',
            component: ViewActivityPage,
            meta: { showActivityNavigation: true, showInActivityNavigation: true }
        },
        {
            path: '/activity/:id/quiz/:quizId?',
            name: 'ViewActivityQuiz',
            component: ViewActivityQuiz,
            meta: { showActivityNavigation: true, showInActivityNavigation: true }
        },
        {
            path: '/activity/:id/',
            name: 'ViewActivityPage',
            component: ViewActivityPage,
            meta: { showActivityNavigation: true, showInActivityNavigation: true }
        },
        {
            path: '/activity/:id/page/:pageId/edit',
            name: 'EditActivityPage',
            component: EditActivityPage,
            meta: { showActivityPageEditNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/activity/:id/quiz/:quizId/edit',
            name: 'EditActivityQuiz',
            component: EditActivityQuiz,
            meta: { showActivityQuizEditNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/activity/:id/share',
            name: 'ShareActivity',
            component: ShareActivity,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster, Role.participant]
            }

        },
        {
            path: '/activity/:id/share-csv',
            name: 'ShareActivityCSV',
            component: ShareActivityCSV,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/activity/:id/scorm/:scormId?',
            name: 'ViewActivityScorm',
            component: ViewActivityScorm,
            meta: { showActivityNavigation: true, showInActivityNavigation: true, hideIfNotEnabledSCORM: true }
        },
        {
            path: '/activity/:id/scorm/:scormId/edit',
            name: 'EditActivityScorm',
            component: EditActivityScorm,
            meta: { showActivityScormEditNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster], hideIfNotEnabledSCORM: true }

        },
        {
            path: '/activity/:id/checklist/:checklistId?',
            name: 'ViewActivityChecklist',
            component: ViewActivityChecklist,
            meta: { showActivityNavigation: true, showInActivityNavigation: true }
        },
        {
            path: '/activity/:id/checklist/:checklistId/edit',
            name: 'EditActivityChecklist',
            component: EditActivityChecklist,
            meta: { showActivityChecklistEditNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }
        },
        {
            path: '/activity/:id/survey/:surveyId?',
            name: 'ViewActivitySurvey',
            component: ViewActivitySurvey,
            meta: { showActivityNavigation: true, showInActivityNavigation: true }
        },
        {
            path: '/activity/:id/survey/:surveyId/edit',
            name: 'EditActivitySurvey',
            component: EditActivitySurvey,
            meta: { showActivitySurveyEditNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/activity/:id/owners/add',
            name: 'AddActivityBoosters',
            component: AddActivityBoosters,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }

        },
        // {
        //     path: '/activity/:id/owners',
        //     name: 'BoostersInActivity',
        //     component: BoostersInActivity,
        //     meta: {
        //         requiresAuth: true,
        //         authorize: [Role.space_admin, Role.booster]
        //     },
        // },
        // {
        //     path: '/activity/:id/people',
        //     name: 'PeopleInActivity',
        //     component: PeopleInActivity,
        //     meta: { requiresAuth: true },
        // },
        {
            path: '/activity/:id/survey/:surveyId',
            name: 'SurveyOverviewParent',
            component: SurveyOverviewParent,
            meta: { requiresAuth: true },
            children: [{
                    path: 'summary',
                    name: 'SurveyOverview',
                    component: SurveyOverview,
                    meta: {
                        requiresAuth: true,
                        overrideRouteKey: true
                    }
                },
                {
                    path: 'individuals',
                    name: 'SurveyIndividuals',
                    component: SurveyIndividuals,
                    meta: {
                        requiresAuth: true,
                        overrideRouteKey: true
                    }
                },
                {
                    path: 'individuals/:attemptId',
                    name: 'SurveyOverviewUser',
                    component: SurveyOverviewUser,
                    meta: {
                        requiresAuth: true,
                        overrideRouteKey: true
                    }
                },

            ]
        },
        {
            path: '/activity/:id',
            name: 'ActivityOverviewParent',
            component: ActivityOverviewParent,
            meta: { requiresAuth: true },
            children: [{
                    path: 'overview',
                    name: 'ActivityOverview',
                    component: ActivityOverview,
                    meta: {
                        requiresAuth: true,
                        overrideRouteKey: true
                    }
                },
                {
                    path: 'owners',
                    name: 'BoostersInActivity',
                    component: BoostersInActivity,
                    meta: {
                        requiresAuth: true,
                        authorize: [Role.space_admin, Role.booster],
                        overrideRouteKey: true
                    },
                },
                {
                    path: 'people',
                    name: 'PeopleInActivity',
                    component: PeopleInActivity,
                    meta: { requiresAuth: true, overrideRouteKey: true },
                },
                {
                    path: 'surveys',
                    name: 'SurveysInActivity',
                    component: SurveysInActivity,
                    meta: {
                        requiresAuth: true,
                        authorize: [Role.space_admin, Role.booster],
                        overrideRouteKey: true
                    },
                },
            ]
        },
        // {
        //     path: '/activity/:id/surveys',
        //     name: 'SurveysInActivity',
        //     component: SurveysInActivity,
        //     meta: {
        //         requiresAuth: true,
        //         authorize: [Role.space_admin, Role.booster]
        //     },
        // },
        {
            path: '/activity/:id/connected-hubs',
            name: 'ConnectedHubs',
            component: ConnectedHubs,
            meta: { requiresAuth: true, hideForFreePlan: true },
        },
        {
            path: '/activity/:id/qr-code',
            name: 'ActivityQRCode',
            component: ActivityQRCode,
            meta: { requiresAuth: true },
        },
        {
            path: '/activity/:id/eduadmin',
            name: 'EduAdminConnection',
            component: EduAdminConnection,
            meta: { requiresAuth: true, hideIfNotEnabledEduAdmin: true },
        },
        {
            path: '/activity/:id/request-become-owner/:requestId',
            name: 'ResponseActivityOwnerRights',
            component: ResponseActivityOwnerRights,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true,
                showActivityNavigation: true,
                showInActivityNavigation: false
            }
        },
        {
            path: '/target-groups/create',
            name: 'CreateTargetGroup',
            component: CreateTargetGroup,
            meta: { requiresAuth: true, authorize: [Role.space_admin, Role.booster], hideForFreePlan: true }
        },
        {
            path: '/target-groups',
            name: 'TargetGroups',
            component: TargetGroups,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] },
        },
        {
            path: '/target-group/:id',
            component: ViewTargetGroup,
            name: 'ViewTargetGroup',
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster], hideForFreePlan: true },
            children: [{
                path: '/audiences/groups/:id/analytics',
                component: TargetGroupAnalytics
            }],
        },
        {
            path: '/target-group/:id/owners',
            component: BoostersInTargetGroup,
            name: 'BoostersInTargetGroup',
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster], hideForFreePlan: true },
        },
        {
            path: '/target-group/:id/add-people',
            component: TargetGroupAddPeople,
            name: 'TargetGroupAddPeople',
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/target-group/:id/owners/add',
            component: AddTargetGroupBoosters,
            name: 'AddTargetGroupBoosters',
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                hideForFreePlan: true
            }
        },
        {
            path: '/terms-of-service',
            name: 'TermsOfService',
            component: TermsOfService
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/register',
            name: 'Registration',
            component: Registration,
            meta: { hideForAuth: true }
        },
        {
            path: '/login',
            name: 'CustomLogin',
            component: CustomLogin,
            meta: { hideForAuth: true }
        },
        {
            path: '/saml-login',
            name: 'SamlLogin',
            component: SamlLogin,
            meta: { hideForAuth: true }
        },
        {
            path: '/verify',
            name: 'Verification',
            component: Verification,
        },
        {
            path: '/reset-password/:token?',
            name: 'ResetPassword',
            component: ResetPassword,
        },
        {
            path: '/space/settings',
            name: 'SpaceSettings',
            component: SpaceSettings,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/space/api',
            name: 'SpaceAPI',
            component: SpaceAPI,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledPublicAPI: true }

        },
        {
            path: '/space/subscription',
            name: 'Subscription',
            component: Subscription,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/space/api/generate-token',
            name: 'GenerateAccessToken',
            component: GenerateAccessToken,
            meta: { requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledPublicAPI: true }

        },
        {
            path: '/space/saml',
            name: 'SpaceSAML',
            component: SpaceSAML,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledSAML: true }

        },
        {
            path: '/space/saml/add-configuration',
            name: 'AddSAMLConfiguration',
            component: AddSAMLConfiguration,
            meta: { requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledSAML: true }

        },
        {
            path: '/space/planday-users',
            name: 'SpacePlandayUsers',
            component: SpacePlandayUsers,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledPlanday: true }

        },
        {
            path: '/space/planday-settings',
            name: 'SpacePlandaySettings',
            component: SpacePlandaySettings,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledPlanday: true }

        },
        {
            path: '/space/eduadmin-settings',
            name: 'SpaceEduAdminSettings',
            component: SpaceEduAdminSettings,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin], hideIfNotEnabledEduAdmin: true }

        },
        {
            path: '/space/fortnox-settings',
            name: 'SpaceFortnoxSettings',
            component: SpaceFortnoxSettings,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/space/visma-settings',
            name: 'SpaceVismaSettings',
            component: SpaceVismaSettings,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/space/connections',
            name: 'SpaceConnections',
            component: SpaceConnections,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/email-templates',
            name: 'EmailTemplates',
            component: EmailTemplates,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin] }

        },
        {
            path: '/audiences/boosters',
            name: 'SpaceBoosters',
            component: SpaceBoosters,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/audiences/people',
            name: 'SpaceUsers',
            component: SpaceUsers,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/audiences/invites',
            name: 'SpaceInvites',
            component: SpaceInvites,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/audiences/guests',
            name: 'SpaceGuests',
            component: SpaceGuests,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/workflows',
            name: 'MyWorkflows',
            component: MyWorkflows,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                workflow: true,
                hideIfNotEnabledWorkflow: true
            }
        },
        /*{
            path: '/workflow/:id/owners',
            name: 'OwnersInWorkflow',
            component: OwnersInWorkflow,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                workflow: true,
                hideIfNotEnabledWorkflow: true
            },
        },
        {
            path: '/workflow/:id/owners/add',
            name: 'AddWorkflowOwners',
            component: AddWorkflowOwners,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
            }

        },*/
        {
            path: '/workflow/:id/people',
            name: 'PeopleInWorkflow',
            component: PeopleInWorkflow,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                workflow: true,
                hideIfNotEnabledWorkflow: true
            },
        },
        {
            path: '/workflow/:id/people/add',
            name: 'AddWorkflowPeople',
            component: AddWorkflowPeople,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
            },
        },
        {
            path: '/workflow/:id',
            name: 'WorkflowOverview',
            component: WorkflowOverview,
            meta: {
                showTopNavigation: true,
                showMenuNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                workflow: true,
                hideIfNotEnabledWorkflow: true
            },
        },
        {
            path: '/workflow/:id/edit',
            name: 'EditWorkflow',
            component: EditWorkflow,
            meta: {
                showWorkflowNavigation: true,
                requiresAuth: true,
                authorize: [Role.space_admin, Role.booster],
                workflow: true,
                hideIfNotEnabledWorkflow: true
            },
        },
        {
            path: '/space/delete',
            name: 'ConfirmationDeleteSpace',
            component: ConfirmationDeleteSpace,
            meta: { requiresAuth: true, authorize: [Role.space_admin, Role.booster] }
        },
        {
            path: '/forbidden',
            name: 'SpaceForbidden',
            component: SpaceForbidden,
            meta: { requiresAuth: true }
        },
        {
            path: '/join/:signature',
            name: 'JoinSpace',
            component: JoinSpace,
        },
        {
            path: '/shared-with-me/activities',
            name: 'SharedWithMe',
            component: SharedWithMe,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }
        },
        {
            path: '/shared-with-me/hubs',
            name: 'SharedWithMeHubs',
            component: SharedWithMeHubs,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster], hideForFreePlan: true }
        },
        {
            path: '/audiences/invite',
            name: 'InvitePeopleForm',
            component: InvitePeopleForm,
            meta: { hideNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }

        },
        {
            path: '/store/',
            name: 'StoreParent',
            component: StoreParent,
            children: [{
                    path: 'overview',
                    name: 'StoreOverview',
                    component: StoreOverview,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'products',
                    name: 'StoreProducts',
                    component: StoreProducts,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'orders',
                    name: 'StoreOrders',
                    component: StoreOrders,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'customers',
                    name: 'StoreCustomers',
                    component: StoreCustomers,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'product/:id',
                    name: 'ViewProduct',
                    component: ViewProduct,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'order/:id',
                    name: 'ViewOrder',
                    component: ViewOrder,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
                {
                    path: 'customer/:id',
                    name: 'ViewStoreCustomer',
                    component: ViewStoreCustomer,
                    meta: {
                        showTopNavigation: true,
                        showMenuNavigation: true,
                        requiresAuth: true,
                        authorize: [Role.space_admin],
                        hideForFreePlan: true
                    }
                },
            ],
        },
        {
            path: '/product/create',
            name: 'CreateStoreProduct',
            component: CreateStoreProduct,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin],
                hideForFreePlan: true
            }
        },
        {
            path: '/customer/create',
            name: 'CreateStoreCustomer',
            component: CreateStoreCustomer,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin],
                hideForFreePlan: true
            }
        },
        {
            path: '/store/customer/:id/customer-contact/create',
            name: 'CreateCustomerContact',
            component: CreateCustomerContact,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin],
                hideForFreePlan: true
            }
        },
        {
            path: '/store/order/:id/add-to-customer',
            name: 'AttachCustomerToOrder',
            component: AttachCustomerToOrder,
            meta: {
                requiresAuth: true,
                authorize: [Role.space_admin],
                hideForFreePlan: true
            }
        },
        {
            path: '/product/:id',
            name: 'ViewProductPublic',
            component: ViewProductPublic,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/product/:id/register',
            name: 'RegisterProductPublic',
            component: RegisterProductPublic,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/order/:id',
            name: 'ViewOrderPublic',
            component: ViewOrderPublic,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/store/policy',
            name: 'StorePolicy',
            component: StorePolicy,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/certificates-participant',
            name: 'MyCertificatesParticipant',
            component: MyCertificatesParticipant,
            meta: {
                showTopNavigation: true,
                requiresAuth: true,
                authorize: [Role.participant, Role.guest],
            }
        },
        {
            path: '/shared-with-me/certificates',
            name: 'MyCertificates',
            component: MyCertificates,
            meta: { showTopNavigation: true, showMenuNavigation: true, requiresAuth: true, authorize: [Role.space_admin, Role.booster] }           
        },
        {
            path: '/403-forbidden',
            name: 'PageAccessDenied',
            component: PageAccessDenied
        },
        {
            path: '/redirect',
            name: 'PageRedirect',
            component: PageRedirect
        },
        {
            path: '/not-exist',
            name: 'SpaceNotExist',
            component: SpaceNotExist
        },
        {
            path: '/:catchAll(.*)*',
            name: 'PageNotFound',
            component: PageNotFound
        },
        {
            path: '/:catchAll(.*)*',
            name: 'PageMaintenanceMode',
            component: PageMaintenanceMode
        }
    ]
});

router.beforeEach(async(to, from, next) => {
    const { authorize } = to.meta;
    const currentUser = localStorage.space ? JSON.parse(localStorage.space).role : null;
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (window.$cookies.get("token") == null) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        } else {
            if (authorize) {
                if (currentUser != null) {
                    if (to.matched.some(record => record.meta.hideForFreePlan)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.name == 'Free') {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.name == 'Free') {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledSCORM)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.scorm_packages == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.scorm_packages == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledSAML)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.sso == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.sso == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledPlanday)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.planday_integration == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.planday_integration == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledEduAdmin)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.eduadmin_integration == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.eduadmin_integration == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledPublicAPI)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.public_api == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.public_api == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (to.matched.some(record => record.meta.hideIfNotEnabledWorkflow) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.workflow_module == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.workflow_module == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    }
                    if (!authorize.includes(currentUser)) {
                        next({
                            path: '/403-forbidden',
                        })
                    }
                } else {
                    if (to.matched.some(record => record.meta.hideForFreePlan) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.name == 'Free') {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.name == 'Free') {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledSCORM) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.scorm_packages == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.scorm_packages == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledSAML) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.sso == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.sso == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledPlanday) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.planday_integration == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.planday_integration == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledEduAdmin) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.eduadmin_integration == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.eduadmin_integration == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledPublicAPI) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.public_api == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.public_api == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else if (to.matched.some(record => record.meta.hideIfNotEnabledWorkflow) && authorize.includes(currentUser)) {
                        if (store.state.productPlan.attributes) {
                            if (store.state.productPlan.attributes.workflow_module == 0) {
                                next({ name: 'PageNotFound' })
                            }
                        } else {
                            const space = window.location.host.split(".")[0];
                            const response = await getSpaceByURLWithoutToken(space)
                            await store.dispatch("getSubscribedPlan", response.data.data).then(() => {
                                if (store.state.productPlan.attributes.workflow_module == 0) {
                                    next({ name: 'PageNotFound' })
                                }
                            })
                        }
                    } else {
                        next({
                            path: '/redirect',
                            query: { redirect: to.fullPath }
                        })
                    }
                }
            }
            if (to.path == '/') {
                if (currentUser == 'space_admin' || currentUser == 'booster') {
                    to.meta.showMenuNavigation = true;
                } else if (currentUser == 'guest' || currentUser == 'participant') {
                    to.meta.showMenuNavigation = false;
                } else {
                    to.meta.showMenuNavigation = false;
                }

            }
            next();
        }
    } else if (to.matched.some(record => record.meta.hideForAuth)) {
        if (window.$cookies.get("token") != null) {
            if (authorize) {
                if (!authorize.includes(currentUser)) {
                    next({
                        path: '/403-forbidden',
                    })
                }
            }
            next({
                path: '/',
            })

        } else {
            next();
        }
    } else {
        next();
    }
})

export default router;